import { render, staticRenderFns } from "./LicenseBanner.vue?vue&type=template&id=d4888714&scoped=true&"
import script from "./LicenseBanner.vue?vue&type=script&lang=ts&"
export * from "./LicenseBanner.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseBanner.vue?vue&type=style&index=0&id=d4888714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4888714",
  null
  
)

export default component.exports